import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useSavePatientHealthIdentifiers = () => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (data) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/patienthealthidentifiers`,
        data
      );
      return response.data;
    },
    meta: { skipGlobalError: true },
  });
};
